const ALWAYS_OMITTED = ['workflowId', 'projectId']

const removeKey = (object, key) =>
  Object.fromEntries(Object.entries(object).filter(([name]) => name !== key))

const stripProperty = (schemaNode, key) => {
  if (!schemaNode || !schemaNode.properties) {
    return schemaNode
  }

  return {
    ...schemaNode,
    properties: removeKey(schemaNode.properties, key),
    ...(Array.isArray(schemaNode.required)
      ? { required: schemaNode.required.filter((name) => name !== key) }
      : {})
  }
}

// Removes a property at a dotted path, unwrapping array nodes via their items.
const stripAtPath = (schemaNode, [head, ...rest]) => {
  if (!schemaNode || !schemaNode.properties) {
    return schemaNode
  }

  if (rest.length === 0) {
    return stripProperty(schemaNode, head)
  }

  const child = schemaNode.properties[head]
  if (!child) {
    return schemaNode
  }

  const isArrayNode = child.type === 'array' && child.items
  const transformed = stripAtPath(isArrayNode ? child.items : child, rest)
  const nextChild = isArrayNode ? { ...child, items: transformed } : transformed

  return {
    ...schemaNode,
    properties: { ...schemaNode.properties, [head]: nextChild }
  }
}

export const translateTool = (mcpTool, omit = []) => {
  const strippedSchema = [...ALWAYS_OMITTED, ...omit].reduce(
    (schema, entry) => stripAtPath(schema, entry.split('.')),
    mcpTool.inputSchema || {}
  )

  return {
    type: 'function',
    name: mcpTool.name,
    description: mcpTool.description,
    strict: false,
    parameters: {
      type: strippedSchema.type || 'object',
      properties: strippedSchema.properties || {},
      required: strippedSchema.required || [],
      additionalProperties: false
    }
  }
}
